import React, { Fragment } from 'react';

import useAthleteEntry from './UseAthleteEntry';

import AthleteEntryGrid from './AthleteEntryGrid';
import DeleteOmeModalInfo from '../meetHost/DeleteOmeModalInfo';

import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import Headings from '@usas/ui-web/components/headings/Headings';
import Input from '@usas/ui-web/components/inputs/Input';
import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import ReportPeriodDropdown from '@usas/ui-web/components/dropdowns/reportPeriodDropdown/ReportPeriodDropdown';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

import Constants from '@usas/ui-web/utils/Constants';

const AthleteEntry = () => {
  const {
    formState,
    errorState,
    modalState,
    omeMeetAthleteEntryState,
    onFormValueChanged,
    onValueTextPairChanged,
    omeMeetAthleteEntryStatusState,
    USAS_ORGANIZATION_ID,
    onCreateEntryClicked,
    onEditEntryClicked,
    onDeleteEntryClicked,
    onDeleteAthleteEntry,
    onFilterClicked,
    onClearFilterClicked,
    onModalCanceled,
    displayLoadingPopUp,
    onEnterANewMeetButtonClicked
  } = useAthleteEntry();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Athlete Entry</Headings.H3>
        </div>
      </div>
      <form>
        <div className='row'>
          <div className='col-xs-12 col-sm-6 col-md-3'>
            <Input
              label="Meet Name"
              name="meetName"
              value={formState.meetName}
              error={errorState.meetName}
              message={errorState.meetName}
              onChange={(value) => { onFormValueChanged('meetName', value); }}
            />
          </div>
          <div className='col-xs-12 col-sm-6 col-md-3'>
            <Dropdown
              label="Athlete Entry Status"
              name="athleteEntryStatusId"
              options={omeMeetAthleteEntryStatusState}
              value={formState.athleteEntryStatusId}
              error={errorState.athleteEntryStatusId}
              message={errorState.athleteEntryStatusId}
              isLoading={false}
              onChange={(value) => { onFormValueChanged('athleteEntryStatusId', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <ReportPeriodDropdown
              label="Registration Year"
              name="reportPeriodId"
              value={formState.reportPeriodId}
              error={errorState.reportPeriodId}
              message={errorState.reportPeriodId}
              onChange={(newValue, newValueLabel) =>
                onValueTextPairChanged(newValue, 'reportPeriodId', newValueLabel, 'reportPeriodName')}
              organizationId={USAS_ORGANIZATION_ID}
              defaultOption={true}
              currentAndFutureOptionsOnly={false} />
          </div>
          <div className='col-xs-6 col-sm-2 col-md-1'>
            <button className={global.PlainButton} onClick={(e) => onFilterClicked(e)}>Filter</button>
          </div>
          <div className='col-xs-6 col-sm-4 col-md-2'>
            <button className={global.PlainButton} onClick={(e) => onClearFilterClicked(e)}>Clear Filter</button>
          </div>
        </div>
      </form>
      <div className='row usas-extra-top-margin'>
        {omeMeetAthleteEntryState.arrayData?.length > 15 && omeMeetAthleteEntryState.isArrayLoading === false &&
          <div className='visible-md visible-lg'>
            <div className="col-xs-12 usas-extra-top-margin">
              <ActionIntraPageButton onClick={onEnterANewMeetButtonClicked}>Search For a New Meet to Enter</ActionIntraPageButton>
            </div>
          </div>
        }
        {omeMeetAthleteEntryState.arrayData?.length > 0 && omeMeetAthleteEntryState.isArrayLoading === false &&
          <div className='hidden-md hidden-lg'>
            <div className="col-xs-12 usas-extra-top-margin">
              <ActionIntraPageButton onClick={onEnterANewMeetButtonClicked}>Search For a New Meet to Enter</ActionIntraPageButton>
            </div>
          </div>
        }
        <div className='col-xs-12'>
          <AthleteEntryGrid
            state={omeMeetAthleteEntryState}
            onCreate={onCreateEntryClicked}
            onEdit={onEditEntryClicked}
            onDeleteClicked={onDeleteEntryClicked}
          />
        </div>
      </div>
      <div className='row usas-extra-top-margin'>
        <div className='col-xs-12 usas-extra-top-margin'>
          <ActionIntraPageButton onClick={onEnterANewMeetButtonClicked}>Search For a New Meet to Enter</ActionIntraPageButton>
        </div>
      </div>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={modalState.modalTitle}
        displayPopUp={modalState.displayPopUp}
        onModalCanceled={onModalCanceled}>
        <div className="row">
          <div className='col-xs-12'>
            <DeleteOmeModalInfo modalState={modalState} />
            <p><strong>Athlete:</strong> {modalState?.athleteName} ({modalState?.athleteCompetitionCategory}, {modalState?.athleteAgeAtMeet})</p>
            <p><strong>Athlete Birth Date:</strong> {modalState?.athleteBirthDate}</p>
            <p><strong>Athlete Entry Status:</strong> {modalState?.athleteEntryStatus}</p>
            <p><strong>Team Name:</strong> {modalState?.orgUnitName}</p>
          </div>
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={(e) => onDeleteAthleteEntry(e, modalState.orgUnitAthleteEntryId)}>Delete</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={displayLoadingPopUp}
      />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={omeMeetAthleteEntryState.isSaving}
      />
    </Fragment>
  );
};

export default AthleteEntry;